import { Form, InputNumber } from 'antd'
import { NamePath } from 'antd/es/form/interface'
import { FC, useCallback, useMemo } from 'react'
import { requiredInputNumberRules } from '../../../../../../../constants/forms/validation/rules'
import useFormInstance from 'antd/es/form/hooks/useFormInstance'

interface MaterialAmountProps {
    name: NamePath
    rest?: { fieldKey?: number }
    materialTypeDocId: string
    configurationsName: NamePath
    disabled?: boolean
}

const MaterialAmount: FC<MaterialAmountProps> = ({ name, rest, configurationsName, disabled }) => {
    const form = useFormInstance()

    const actionName = useMemo(
        () => [...configurationsName, name, 'action'],
        [configurationsName, name]
    )

    const triggerConfigurationsValidation = useCallback(() => {
        void form.validateFields([configurationsName]).catch(() => undefined)
    }, [configurationsName, form])

    const validateAmount = useCallback(
        (_rule: any, amount: number) => {
            const action = form.getFieldValue(actionName)

            if (amount == null || amount <= 0) {
                return Promise.reject(new Error('Должно быть больше 0'))
            }

            if (action === 'Заказать' && amount % 1 !== 0) {
                return Promise.reject(new Error('Должно быть целым числом'))
            }

            return Promise.resolve()
        },
        [actionName, form]
    )
    return (
        <Form.Item
            name={[name, 'amount']}
            label={'Кол-во'}
            {...rest}
            dependencies={[actionName]}
            validateTrigger={['onChange', 'onBlur']}
            rules={[...requiredInputNumberRules, { validator: validateAmount }]}
        >
            <InputNumber
                min={0.1}
                style={{ width: '100%' }}
                onChange={triggerConfigurationsValidation}
                disabled={disabled}
            />
        </Form.Item>
    )
}

export default MaterialAmount
